/** Opens turn-by-turn directions to the clinic in the device's maps app. */
export const directionsUrl = (clinic) => {
  if (clinic?.mapUrl) return clinic.mapUrl;
  if (clinic?.latitude && clinic?.longitude) {
    return `https://www.google.com/maps/dir/?api=1&destination=${clinic.latitude},${clinic.longitude}`;
  }
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(clinic?.address || '')}`;
};

export const openDirections = (clinic) => {
  window.open(directionsUrl(clinic), '_blank', 'noopener');
};

const mapsService = { directionsUrl, openDirections };
export default mapsService;
